import { createContext } from 'react';
import { CreateFormIdVariant } from './createFormActions';

export const CreateFormContext = createContext<CreateFormIdVariant>('simple');

export const CreateFormProvider = CreateFormContext.Provider;
